export const questions = [
  {
    'ID': '0',
    'TEXT': 'Don´t worry mate, u design is not that ugly',
    'CATEGORY': 'End',
    'ANSWERS': [
      {
        'ID': '0.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '1',
    'TEXT': 'Is ur design ugly?',
    'CATEGORY': 'id1',
    'ANSWERS': [
      {
        'ID': '1.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '2',
      },
      {
        'ID': '1.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '2',
    'TEXT': 'Do someone told u is ugly?',
    'CATEGORY': 'id1',
    'ANSWERS': [
      {
        'ID': '2.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '3',
      },
      {
        'ID': '2.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '3',
    'TEXT': 'How many people think is ugly?',
    'CATEGORY': 'id1',
    'ANSWERS': [
      {
        'ID': '3.1',
        'TEXT': 'Just 1',
        'TYPE': 'btn',
        'NEXT': '4',
      },
      {
        'ID': '3.2',
        'TEXT': '2 or more',
        'TYPE': 'btn',
        'NEXT': '6',
      },
    ]
  },
  {
    'ID': '4',
    'TEXT': 'Is he/she a designer?',
    'CATEGORY': 'id1',
    'ANSWERS': [
      {
        'ID': '4.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '5',
      },
      {
        'ID': '4.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '5',
    'TEXT': 'Ask him for help, don´t use this crappy tool',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '5.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '6',
    'TEXT': 'Do you know what is making ugly your design?',
    'CATEGORY': 'id6',
    'ANSWERS': [
      {
        'ID': '6.1',
        'TEXT': 'It have ugly colors',
        'TYPE': 'multi',
        'NEXT': '7',
      },
      {
        'ID': '6.2',
        'TEXT': 'It have ugly photos',
        'TYPE': 'multi',
        'NEXT': '11',
      },
      {
        'ID': '6.3',
        'TEXT': 'It have ugly fonts',
        'TYPE': 'multi',
        'NEXT': '15',
      },
      {
        'ID': '6.4',
        'TEXT': 'It have too many things',
        'TYPE': 'multi',
        'NEXT': '19',
      }
    ]
  },
  {
    'ID': '7',
    'TEXT': 'How many colors does it have in total?',
    'CATEGORY': 'id7',
    'ANSWERS': [
      {
        'ID': '7.1',
        'TEXT': '1 to 3',
        'TYPE': 'btn',
        'NEXT': '8',
      },
      {
        'ID': '7.2',
        'TEXT': 'More than 4',
        'TYPE': 'btn',
        'NEXT': '10',
      },
    ]
  },
  {
    'ID': '8',
    'TEXT': 'Do you think your colors are ugly?',
    'CATEGORY': 'id7',
    'ANSWERS': [
      {
        'ID': '8.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '9',
      },
      {
        'ID': '8.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '9',
    'TEXT': 'Try to use nicer colors',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '9.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '10',
    'TEXT': 'Try to reduce the colors to a maximum of 3',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '10.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '11',
    'TEXT': 'How many photos does it have in total?',
    'CATEGORY': 'id11',
    'ANSWERS': [
      {
        'ID': '11.1',
        'TEXT': 'One',
        'TYPE': 'btn',
        'NEXT': '13',
      },
      {
        'ID': '11.2',
        'TEXT': 'More than one',
        'TYPE': 'btn',
        'NEXT': '14',
      },
    ]
  },
  {
    'ID': '12',
    'TEXT': 'Do you think this photo is ugly?',
    'CATEGORY': 'id11',
    'ANSWERS': [
      {
        'ID': '12.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '13',
      },
      {
        'ID': '12.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '13',
    'TEXT': 'Try to use a nicer photo',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '13.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '14',
    'TEXT': 'Try to use only one photo',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '14.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '15',
    'TEXT': 'How many fonts does it have in total?',
    'CATEGORY': 'id15',
    'ANSWERS': [
      {
        'ID': '15.1',
        'TEXT': '1',
        'TYPE': 'btn',
        'NEXT': '16',
      },
      {
        'ID': '15.2',
        'TEXT': 'More than 1',
        'TYPE': 'btn',
        'NEXT': '18',
      },
      {
        'ID': '15.2',
        'TEXT': 'What is a font?',
        'TYPE': 'link',
        'NEXT': 'https://en.wikipedia.org/wiki/Font',
        
      },
    ]
  },
  {
    'ID': '16',
    'TEXT': 'Do the font is Comic Sans?',
    'CATEGORY': 'id15',
    'ANSWERS': [
      {
        'ID': '16.1',
        'TEXT': 'Yes',
        'TYPE': 'btn',
        'NEXT': '17',
      },
      {
        'ID': '16.2',
        'TEXT': 'No',
        'TYPE': 'btn',
        'NEXT': '0',
      },
    ]
  },
  {
    'ID': '17',
    'TEXT': 'Try to use a nicer font',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '17.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '18',
    'TEXT': 'Try to use only one font',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '18.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
  {
    'ID': '19',
    'TEXT': 'Try to use less stuff',
    'CATEGORY': 'Stap',
    'ANSWERS': [
      {
        'ID': '19.1',
        'TEXT': 'Start again',
        'TYPE': 'btn',
        'NEXT': '1',
      }
    ]
  },
]
